module.exports = __webpack_public_path__ + "static/media/image_chat.f7bc5701.png";